import React from 'react';

interface StepHeadingProps {
  index: number;
  kicker: string;
  title: string;
  /** Trailing fragment of the title, rendered in brand pigment. */
  accent?: string;
  lede?: string;
}

const StepHeading: React.FC<StepHeadingProps> = ({ index, kicker, title, accent, lede }) => (
  <header className="ed-head">
    <div className="ed-head-body">
      <span className="ed-kicker">
        <span className="ed-kicker-num">{String(index).padStart(2, '0')}</span>
        {kicker}
      </span>
      <h1 className="ed-display">
        {title}
        {accent && <span className="ed-accent"> {accent}</span>}
      </h1>
      {lede && <p className="ed-lede">{lede}</p>}
    </div>
  </header>
);

export default StepHeading;
